import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { orgActions } from "../../actions";
import { Link } from "react-router-dom";
import { DocTypeCreate} from "./DocTypeCreate";
import { DocTypeEdit} from "./DocTypeEdit";
import ReactTooltip from "react-tooltip";
import { DEBUG_STATE } from "../../constants/constants.js"

function DocTypeList(props) {
  const { authentication, org, getDocTypes, deleteDocType } = props;

  const org_id = props.match.params.id;
  const doc_types = org?.doc_types;

  const [showCreate, setShowCreate] = useState(false);
  const [docTypeToEdit, setDocTypeToEdit] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  
  const debug=DEBUG_STATE;

  const usersIcon = require("../../images/users.png").default;
  const addicon = require("../../images/add.png").default;
  const editIcon = require("../../images/editicon.png").default;
  const trashIcon = require("../../images/trash.png").default;

  useEffect(() => {
    getDocTypes(org_id);
  }, [])


  const toggleShowCreate = () => {

    setShowCreate(!showCreate);

  }
  const toggleShowEdit = (doctype) => {
    const docTypeToEdit = doctype;
    if (!showEdit) {
      //docTypeToEdit["old_name"] = doctype.doc_type;
      setDocTypeToEdit(docTypeToEdit);
      setShowEdit(true);
    } else {
      setShowEdit(false);
    }

    
  }

  const onClickDelete = (doctype) => {
    const docTypeRequest = (JSON.parse(JSON.stringify(doctype)));
    docTypeRequest.org_id = org_id;
    deleteDocType(docTypeRequest);
  }

  const headers = ["doc type", "count", ""];


  const generateRowHeaders = () => {

    return (
      <>
        <th width="3%" key="doctype icon">&nbsp;</th>
        <th width="37%" key="file name">document type</th>
        <th width="3%" key="edit docytpe">&nbsp;</th>
        <th width="3%" key="delete docytpe">&nbsp;</th>
        <th width="20" key="num files"># of files</th>
        <th width="20%" key="num users"># of users</th>
        <th width="3%" key="usersIcon">&nbsp;</th>
      </>
    )
  };


  const tableRows = !doc_types
    ? null
    : doc_types?.map((doctype, i) => (
      <>
        <tr>
          <td>
              <span className="docTypeLabel" style={{backgroundColor: "#"+doctype.color}} >
                {doctype.labelCode}
              </span>
          </td>
          <td>{doctype.doc_type}</td>
          <td>
            <div data-tip data-for="edit doctype">
              <img width="20px" src={editIcon} alt="edit" onClick={() => toggleShowEdit(doctype)}/>
              <ReactTooltip id="edit doctype" place="bottom" effect="solid" data-type="info" delayShow={150}>
                edit this document type
              </ReactTooltip>
            </div>
          </td>
          <td>
            <div data-tip data-for="delete doctype">
              <img width="22px" src={trashIcon} alt="delete" onClick={() => onClickDelete(doctype)}/>
              <ReactTooltip id="delete doctype" place="bottom" effect="solid" data-type="info" delayShow={150}>
                delete this document type (must be unassigned)
              </ReactTooltip>
            </div>                        
          </td>
          <td>{doctype.file_count?doctype.file_count:0}</td>
          <td>{doctype.user_count?doctype.user_count:0}</td>
          <td>
            <div data-tip data-for="show doctype users">
              { 
              <Link to={{ pathname: "/org/" + org_id + "/doctype/" + doctype.doc_type + "/users",
                          state: { doctype: doctype }}}>
                <img width="24px" src={usersIcon} alt="list view" />
              </Link>
              }
              {/* 
              <Link to={{ pathname: "/org/" + org_id + "/users"}}>
                <img width="24px" src={usersIcon} alt="list view" />
              </Link>
              */}
              <ReactTooltip id="show doctype users" place="bottom" effect="solid" data-type="info" delayShow={150}>
                show users who can be assigned to this document type
              </ReactTooltip>
            </div>   

          </td>
        </tr>
      </>
    ));


  return (
    <div class="searchMain">
      <div className="contentContainerLeftNav" >
        <div className="rightContent">
          <div>
            <h3>
              Document Types
              &nbsp;&nbsp;&nbsp;
              {authentication.user.roles.includes("ADMIN") && (
                <>
                  <div className="editJacketNameIcon" data-tip data-for="add doctype">
                    {/*



                  */}
                    <span onClick={toggleShowCreate}>
                      <img src={addicon} width="20px" alt="add"/>
                    </span>
                    <ReactTooltip id="add doctype" place="bottom" effect="solid" data-type="info" delayShow={300}>
                      create new document type
                    </ReactTooltip>
                  </div>
                </>
              )}
            </h3>

            <br />
            <div className="createDocTypeModal"style={{ visibility: showCreate ? "visible" : "hidden" }}>
              <DocTypeCreate org_id={org_id} closeModal={toggleShowCreate}/>
            </div>
            <div className="createDocTypeModal"style={{ visibility: showEdit ? "visible" : "hidden" }}>
              <DocTypeEdit key={docTypeToEdit["doc_type"]} org_id={org_id} closeModal={toggleShowEdit} docType={docTypeToEdit}/>
            </div>            
            <table className="paleBlueRows narrow">
              <tbody>
                <thead>
                  {generateRowHeaders()}
                </thead>
                <tbody>
                  {tableRows}
                </tbody>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  );
}

function mapStateToProps(state) {
  const { authentication, org } = state;
  return {
    authentication,
    org,
  };
}

const actionCreators = {
  getDocTypes: orgActions.getDocTypes,
  deleteDocType: orgActions.deleteDocType,
};

const connectedDocTypeList = connect(mapStateToProps, actionCreators)(DocTypeList);
export { connectedDocTypeList as DocTypeList };
